module.exports = __webpack_public_path__ + "static/media/area_chart_icon.5ff45f21.svg";